import { render, staticRenderFns } from "./CampaignHistoryCard.vue?vue&type=template&id=f61f59be"
import script from "./CampaignHistoryCard.vue?vue&type=script&lang=js"
export * from "./CampaignHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignHistoryCard.vue?vue&type=style&index=0&id=f61f59be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports